import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  "@keyframes slideIn": {
    from: {
      transform: "translateX(100%)",
    },
    to: {
      transform: "translateX(0)",
    },
  },

  root: {
    display: "flex",
    flex: "1 1 0",
    flexDirection: "column",
    minHeight: 0,
    position: "relative",
    overflow: "hidden",
  },

  dialogHeader: {
    display: "block",
    flexShrink: 0,
  },

  dialogPaper: {
    position: "absolute",
    top: "0",
    right: "0",
    margin: "0",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    minHeight: "100%",
    width: 480,
    borderRadius: "12px",
    animation: "$slideIn 1s ease-out",
  },

  "@media (max-width: 425px)": {
    dialogPaper: {
      maxWidth: "100%",
      width: "100%",
      height: "100%",
      maxHeight: "100%",
      margin: "0",
      borderRadius: "0",
    },
  },

  ticketInfoWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },

  closeButton: {
    marginLeft: "auto",
    marginRight: "24px",
    borderRadius: "12px",
    padding: "8px",
    gap: "8px",
  },

  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "0",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
}))

export default useStyles
